import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

import Aux from '../../hoc/Auxiliary';
import BackDrop from '../UI/Backdrop/Backdrop';
import PopupBox from '../UI/PopupBox/PopupBox';
import Button from '../UI/Button/Button';
import Input from '../UI/Input/Input';

class SetOpenTime extends Component {
    state = {
        form: {
            openTime: {
                label: 'Open Time',
                elementType: 'select',
                elementConfig: {
                    options: [
                        { value: 4, displayValue: '4am' },
                        { value: 5, displayValue: '5am' },
                        { value: 6, displayValue: '6am' },
                        { value: 7, displayValue: '7am' },
                        { value: 8, displayValue: '8am' },
                        { value: 9, displayValue: '9am' },
                        { value: 10, displayValue: '10am' },
                        { value: 11, displayValue: '11am' },
                    ]
                },
                value: this.props.openTime
            },
            closeTime: {
                label: 'Close Time',
                elementType: 'select',
                elementConfig: {
                    options: [
                        { value: 2, displayValue: '2pm' },
                        { value: 3, displayValue: '3pm' },
                        { value: 4, displayValue: '4pm' },
                        { value: 5, displayValue: '5pm' },
                        { value: 6, displayValue: '6pm' },
                        { value: 7, displayValue: '7pm' },
                        { value: 8, displayValue: '8pm' },
                        { value: 9, displayValue: '9pm' },
                        { value: 10, displayValue: '10pm' },
                        { value: 11, displayValue: '11pm' },
                    ]
                },
                value: this.props.closeTime,
            },
        }
    }

    inputChangedHandler = ( event, inputId ) => {
        const updatedForm = { ...this.state.form };
        const updatedElement = { ...updatedForm[ inputId ] };
        updatedElement.value = event.target.value;
        updatedForm[ inputId ] = updatedElement;
        this.setState( { form: updatedForm } );
    }

    sumbitHandler = () => {
        const openTime = parseInt( this.state.form.openTime.value );
        const closeTime = parseInt( this.state.form.closeTime.value );
        this.props.onSetOpenTime( openTime, closeTime )
        this.props.showToggle();
    }

    render () {
        console.log( this.props )
        return (
            <Aux>
                <BackDrop
                    show={this.props.show}
                    clicked={this.props.showToggle} />
                <PopupBox>
                    <form>
                        <Input
                            elementType={this.state.form.openTime.elementType}
                            label={this.state.form.openTime.label}
                            elementConfig={this.state.form.openTime.elementConfig}
                            value={this.state.form.openTime.value}
                            changed={( event ) => this.inputChangedHandler( event, 'openTime' )}
                        />
                        <Input
                            elementType={this.state.form.closeTime.elementType}
                            label={this.state.form.closeTime.label}
                            elementConfig={this.state.form.closeTime.elementConfig}
                            value={this.state.form.closeTime.value}
                            changed={( event ) => this.inputChangedHandler( event, 'closeTime' )}
                        />
                        <Button clicked={this.sumbitHandler}>UPDATE OPEN TIMES</Button>
                    </form>
                </PopupBox>
            </Aux >
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetOpenTime: ( open, close ) => dispatch( actions.setLabHours( open, close ) )
    }
}

export default connect( null, mapDispatchToProps )( SetOpenTime );